/**
 * Marca do produto. Sem logotipo definitivo ainda: sinal "ML" num quadrado de
 * tinta + o nome em Geist Bold. Não inventar logo; nada de emoji como ícone
 * estrutural (anti-padrão 12).
 */
import { cn } from '../lib/cn';

export interface BrandMarkProps {
  className?: string;
  /** Em sidebar colapsada só o sinal cabe. */
  compact?: boolean;
}

export function BrandMark({ className, compact = false }: BrandMarkProps) {
  return (
    <span className={cn('inline-flex items-center gap-2.5 text-foreground', className)}>
      <span
        aria-hidden="true"
        className="inline-flex size-7 shrink-0 items-center justify-center rounded-sm bg-surface-inverse text-2xs font-bold tracking-tight text-inverse-foreground"
      >
        ML
      </span>
      {compact ? (
        <span className="sr-only">MGDLead</span>
      ) : (
        <span className="text-xl leading-none font-bold tracking-tighter">MGDLead</span>
      )}
    </span>
  );
}
